import { getFeature } from 'Cloud/Application/FeaturesEs6';

/**
 * tempexp_20855: эксперимент CLOUDWEB-20855 — убрать отключение рекламы из Основных тарифов.
 * Меняет пункт «Без рекламы в Почте и Облаке» только у Основных тарифов.
 * a — контроль, текст не меняется («Без рекламы в Почте и Облаке»)
 * b — частичная рекламная нагрузка в Почте, текст «Без рекламы в Облаке»
 * c — полная рекламная нагрузка, текст «Разбор фото свайпами»
 */
export const disableAdsBasicTariff: 'a' | 'b' | 'c' = getFeature('disable-ads-basic-tariff') || 'a';
